import PropTypes from 'prop-types';
import React from 'react';

const DownArrowIcon = ({ className, color = '#153142' }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0570021 0.214644C0.019001 0.273044 -1.47045e-08 0.336644 -1.74846e-08 0.400244C-2.09815e-08 0.480244 0.0300007 0.559444 0.0890026 0.627844L4.5891 5.82784C4.6826 5.93584 4.83611 6.00024 5.00011 6.00024C5.16411 6.00024 5.31762 5.93584 5.41112 5.82784L9.91122 0.627844C10.0167 0.505844 10.0292 0.346244 9.94322 0.214644C9.85672 0.082644 9.68621 0.000244127 9.50021 0.000244119L0.500011 0.000243725C0.314008 0.000243717 0.143504 0.0826436 0.0570021 0.214644Z"
      fill={color}
    />
  </svg>
);

DownArrowIcon.propTypes = {
  className: PropTypes.string,
};

DownArrowIcon.defaultProps = {
  className: undefined,
};

export default DownArrowIcon;
